export default {
  chatWidget: {
    chatWithUs: '與我們聯絡',
    welcomeTitle: '歡迎來到 Bookivo!',
    welcomeMessage: '今天有什麼可以幫助您的嗎?',
    continueChat: '繼續對話',
    startConversation: '開始對話',
    formTitle: '請告訴我們更多關於您的資訊',
    namePlaceholder: '您的姓名',
    emailPlaceholder: '您的電子郵件',
    phonePlaceholder: '您的電話號碼',
    nameRequired: '請輸入您的姓名',
    emailRequired: '請輸入您的電子郵件',
    emailInvalid: '請輸入有效的電子郵件地址',
    phoneRequired: '請輸入您的電話號碼',
    startChat: '開始聊天',
    chatTitle: '客服對話',
    chatTitleNoAgent: '連接中...',
    endChat: '結束會話',
    inputPlaceholder: '輸入您的訊息...',
    greeting: '您好',
    greetingMessage: '今天有什麼可以幫助您的嗎?',
    emoji: '表情',
    uploadImage: '上傳圖片',
    sending: '發送中...',
    uploadFailed: '上傳失敗，請重試',
    fileTooLarge: '檔案大小不能超過10MB',
    invalidFileType: '只能上傳圖片檔案',
    sendFailed: '訊息發送失敗，請重試',
    imageSendFailed: '圖片發送失敗，請重試',
    connectionLost: '連線已中斷，請關閉聊天視窗重新連線',
    uploading: '正在上傳圖片...',
    sessionEnded: '會話已結束',
    rating: {
      title: '感謝您使用我們的服務，請為此次服務進行評價！',
      satisfied: '滿意',
      dissatisfied: '不滿意',
      placeholder: '歡迎為我們的服務提建議',
      submit: '提交評價',
      endChat: '立即結束',
      backToChat: '返回聊天',
      success: '感謝您的反饋！'
    }
  }
}
